import { fn } from '@ember/helper';
import { get } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import perform from 'ember-concurrency/helpers/perform';
import eq from 'ember-truth-helpers/helpers/eq';
import DialysisEditionForm from 'parog-web/components/dialysis/edition-form';
import BeforeSessionEditionForm from 'parog-web/components/dp-cycle/edition-form/before-session-edition-form';
import CycleSessionEditionForm from 'parog-web/components/dp-cycle/edition-form/cycle-session-edition-form';
import EndSessionEditionForm from 'parog-web/components/dp-cycle/edition-form/end-session-edition-form';
import type DpSessionDeclaredModelView from 'parog-web/models/dp-session-declared-model-view';
import PageContainer from 'ui-kit/components/page-container';
import SelectableButtonGroup from 'ui-kit/components/selectable-button-group';

interface Signature {
  Args: {
    sessionMeasurement: DpSessionDeclaredModelView;
  };
}

export default class DpSessionEditionFormComponent extends Component<Signature> {
  @tracked currentState = 'before';

  get cyclesPocketDrainedVolume(): (number | undefined)[] {
    return this.args.sessionMeasurement.measurementChangesets.middle.map(c =>
      c.get('cyclePocketDrainedVolume')
    );
  }

  get cyclesPocketInfusedVolume(): (number | undefined)[] {
    return this.args.sessionMeasurement.measurementChangesets.middle.map(c =>
      c.get('cyclePocketInfusedVolume')
    );
  }

  <template>
    <PageContainer @title='Séance de dialyse péritonéale'>
      <:content>
        <DialysisEditionForm
          @sessionMeasurement={{@sessionMeasurement}}
          @currentState={{this.currentState}}
          as |submit|
        >
          <SelectableButtonGroup
            @onChange={{fn (mut this.currentState)}}
            @selected={{this.currentState}}
            @xs={{true}}
            as |Group|
          >
            <Group.Item class='small w-1/3' @value='before'>Avant</Group.Item>
            <Group.Item class='small w-1/3' @value='cycle'>Cycles</Group.Item>
            <Group.Item class='small w-1/3' @value='end'>Fin</Group.Item>
          </SelectableButtonGroup>

          {{#if (eq this.currentState 'before')}}
            <div class='mt-4 md:mt-0'>
              <BeforeSessionEditionForm
                @measurement={{get
                  @sessionMeasurement.measurementChangesets.start
                  0
                }}
                @onSubmit={{perform submit}}
              />
            </div>
          {{/if}}

          {{#if (eq this.currentState 'cycle')}}
            <div class='mt-4 md:mt-0'>
              <CycleSessionEditionForm
                @measurements={{@sessionMeasurement.measurementChangesets.middle}}
                @onSubmit={{perform submit}}
              />
            </div>
          {{/if}}

          {{#if (eq this.currentState 'end')}}
            <div class='mt-4 md:mt-0'>

              <EndSessionEditionForm
                @measurement={{get
                  @sessionMeasurement.measurementChangesets.end
                  0
                }}
                @onSubmit={{perform submit}}
                @cyclesPocketInfusedVolume={{this.cyclesPocketInfusedVolume}}
                @cyclesPocketDrainedVolume={{this.cyclesPocketDrainedVolume}}
              />
            </div>
          {{/if}}
        </DialysisEditionForm>

      </:content>
    </PageContainer>
  </template>
}
